export default __webpack_public_path__ + "0c4dec4c6ecb4e05e9cd60577fa53102.svg";